// extracted by mini-css-extract-plugin
export var divider = "_f0-7";
export var itemsToggle = "_f0-8";
export var mergeModal = "_f0-1";
export var optionCard = "_f0-4";
export var radioGroup = "_f0-6";
export var radioOption = "_f0-0";
export var selected = "_f0-5";
export var shipmentOptions = "_f0-2";
export var tableOptions = "_f0-3";